import { z } from 'zod'

import {
  dataDisplayTypes,
  fiveSegments,
  groups,
  groupsAndAll,
  resultViewerTypes,
} from '~/utils'

import {
  type IndividualSortColumnKey,
  type SequentialSortColumnKey,
} from '../../../utils'
import {
  type RestoringParams,
  type RestoringParamsAddition,
  type RestoringParamsOrigin,
} from '../types'

export const schema2Origin = z.object({
  version: z.literal(2),
  revision: z.number(),
  brandGroupId: z.number(),
  brand1Id: z.number().nullable(),
  brand2Id: z.number().nullable(),
  dataDisplayType: z.enum(dataDisplayTypes),
  groupInfos: z.array(
    z.object({
      brand1: z.enum(['all', ...fiveSegments]),
      brand2: z.enum(['all', ...fiveSegments]),
      group: z.enum(groups),
    }),
  ),
  resultViewerType: z.enum(resultViewerTypes),
  questionIds: z.array(z.string()),
  groupNameMap: z.record(z.string(), z.string()),
  sequentialSortValue: z
    .object({
      columnKey: z.custom<SequentialSortColumnKey>(
        (data) =>
          // 簡略化のため string なら ok としている
          // /(group([1-9]|1[0-5])(vsgroup([1-9]|1[0-5]))?|all)/.test(
          //   data as string,
          // ),
          typeof data === 'string',
      ),
      ascending: z.boolean(),
    })
    .nullable(),
  individualSortValue: z
    .object({
      columnKey: z.custom<IndividualSortColumnKey>(
        (data) =>
          // 簡略化のため string なら ok としている
          // /(group([1-9]|1[0-5])(vsgroup([1-9]|1[0-5]))?|all)/.test(
          //   data as string,
          // ),
          typeof data === 'string',
      ),
      ascending: z.boolean(),
    })
    .nullable(),
  matrixSortValue: z
    .object({
      columnKey: z.string(),
      ascending: z.boolean(),
    })
    .nullable(),
  hiddenRowIds: z.array(z.string()),
  hash: z.string(),
}) satisfies z.ZodSchema<RestoringParamsOrigin>

const schema2Addition = z.object({
  comment: z.string(),
  customerAttributeIds: z.array(z.string()),
  groupsDiffs: z.array(z.tuple([z.enum(groupsAndAll), z.enum(groupsAndAll)])),
  questionsDiffsMap: z.record(
    z.string(),
    z.array(z.tuple([z.string(), z.string()])),
  ),
  hiddenColumnKeys: z.array(z.string()),
}) satisfies z.ZodSchema<RestoringParamsAddition>

export const schema2 = schema2Origin.merge(
  schema2Addition.partial(),
) satisfies z.ZodSchema<RestoringParams>
